<template>
    <base-tool
        :tool-name="tool.name"
        :tool-description="tool.description"
        @back="goBack"
    >
        <el-radio-group 
            v-model="type"
            data-testid="transfer-tool-radio-group"
        >
            <el-radio
                :label="AloAi.TRANSFER_CALL_TYPE_RING_GROUP"
                data-testid="transfer-tool-radio-ring-group"
            >
                <span v-if="type !== AloAi.TRANSFER_CALL_TYPE_RING_GROUP">Transfer to inbox</span>                
                <ring-group-selector
                    v-if="type === AloAi.TRANSFER_CALL_TYPE_RING_GROUP"
                    v-model="selected_ring_group_id"
                    data-testid="transfer-tool-ring-group-selector"
                    @change="handleRingGroupChange">
                </ring-group-selector>
            </el-radio>

            <el-radio
                :label="AloAi.TRANSFER_CALL_TYPE_USER"
                data-testid="transfer-tool-radio-user"
            >
                <span v-if="type !== AloAi.TRANSFER_CALL_TYPE_USER">Transfer to user</span>                
                <user-selector 
                    v-if="type === AloAi.TRANSFER_CALL_TYPE_USER"
                    :placeholder='"Select user"'
                    v-model="selected_user_id"
                    data-testid="transfer-tool-user-selector"
                    @change="handleUserChange">
                </user-selector>
            </el-radio>

            <el-radio
                :label="AloAi.TRANSFER_CALL_TYPE_LINE"
                data-testid="transfer-tool-radio-line"
            >
                <span v-if="type !== AloAi.TRANSFER_CALL_TYPE_LINE">Transfer to line</span>                
                <campaign-selector
                    v-if="type === AloAi.TRANSFER_CALL_TYPE_LINE"
                    data-testid="transfer-tool-campaign-selector"
                    check_blocked_messaging
                    is_automated
                    :show_paused="false"
                    @input="handleCampaignChange">
                </campaign-selector>
            </el-radio>
        </el-radio-group>                        
    </base-tool>
</template>

<script>
import * as AloAi from '../../../../constants/aloai'
import CampaignSelector from '../../../campaign-selector'
import RingGroupSelector from '../../../ring-group-selector'
import UserSelector from '../../../user-selector'
import BaseTool from './base-tool.vue'
import ToolMixin from './tool-mixin'

export default {
    name: 'TransferTool',

    mixins: [ToolMixin],

    components: {
        BaseTool,
        CampaignSelector,
        RingGroupSelector,
        UserSelector
    },

    props: {
        tool: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            AloAi,
            selected_ring_group_id: null,
            selected_user_id: null,
            selected_campaign_id: null,        
            type: null,
        }
    },

    methods: {        
        handleRingGroupChange(ringGroupId) {
            this.selected_ring_group_id = ringGroupId;
            this.saveTransferConfig();
        },
        
        handleUserChange(userId) {
            this.selected_user_id = userId;
            this.saveTransferConfig();
        },
        
        handleCampaignChange(campaignId) {
            this.selected_campaign_id = campaignId;
            this.saveTransferConfig();
        },
                
        saveTransferConfig() {
            let transferData = null;
            
            if (this.type === AloAi.TRANSFER_CALL_TYPE_RING_GROUP && this.selected_ring_group_id) {
                const ringGroup = this.$store.state.ring_groups.find(rg => rg.id === this.selected_ring_group_id);
                
                if (ringGroup) {
                    transferData = {
                        type: 'ring_group',
                        id: this.selected_ring_group_id,
                        text: '{Transfer to this ring group: ' + ringGroup.name + '|' + ringGroup.id + '}',
                    };
                }
            } else if (this.type === AloAi.TRANSFER_CALL_TYPE_USER && this.selected_user_id) {
                const user = this.$store.state.users.find(u => u.id === this.selected_user_id);

                if (user) {
                    transferData = {
                        type: 'user',
                        id: this.selected_user_id,
                        text: '{Transfer to this user: ' + user.name + '|' + user.id + '}',
                    };
                }
            } else if (this.type === AloAi.TRANSFER_CALL_TYPE_LINE && this.selected_campaign_id) {                
                const campaign = this.$store.state.campaigns.find(c => c.id == this.selected_campaign_id);

                if (campaign) {
                    transferData = {
                        type: 'line',
                        id: this.selected_campaign_id,
                        text: '{Transfer to this line: ' + campaign.name + '|' + this.selected_campaign_id + '}',
                    };             
                }              
            }
            
            if (transferData) {
                this.$emit('transfer-call-selected', transferData);
            }
        }
    },
}
</script>

<style scoped>
.el-radio-group {
    width: 100%;
}

.el-radio {
    width: 100%;
    display: flex;
    align-items: center;
}
</style>
